module.exports = __webpack_public_path__ + "static/media/cover-crane-health-and-safety.e0205307.jpg";